import script from "./StatsFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsFilters.vue?vue&type=script&setup=true&lang=js"

import "./StatsFilters.vue?vue&type=style&index=0&id=5b20e7f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b20e7f8"]])

export default __exports__